import React, { FC } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useHistory } from 'react-router';
import { CellProps, Column } from 'react-table';
import MainLayout from 'components/main-layout/MainLayout';
import FetchTable from 'components/table/FetchTable';
import Button from 'components/Button';
import Badge from 'components/Badge';
import TooltipWrapper from 'components/TooltipWrapper';
import DeleteEntity from 'components/crud/DeleteEntity';
import { buildClientEntity, buildClientUrl } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import { ISegment } from '../types';

export interface IProps {
  entityName: string;
  entityEndpoint: string;
  displayName: string;
}

const List: FC<IProps> = ({ entityName, entityEndpoint, displayName }) => {
  const history = useHistory();
  const { client } = useActiveClientContext();
  const createSegment = () => history.push(buildClientUrl('/segments/create', client));

  const columns: Array<Column<ISegment>> = [
    {
      Header: 'ID',
      accessor: 'id',
    },
    {
      Header: 'ID',
      accessor: 'snippet',
      minWidth: 250,
      Cell: (cell: CellProps<ISegment>) => {
        return <span className="text-uppercase">{`[${displayName}-${cell.row.original.id}]`}</span>;
      },
    },
    {
      Header: 'Име',
      accessor: 'name',
      width: '100%',
    },
    {
      Header: 'Статус',
      accessor: 'status',
      width: '100%',
      minWidth: 100,
      disableSortBy: true,
      Cell: (cell: CellProps<ISegment>) => {
        if (cell.row.original.is_active)
          return (
            <Badge
              label="Активен"
              variant="primary"
            />
          );

        return (
          <Badge
            label="Неактивен"
            variant="danger"
          />
        );
      },
    },
    {
      Header: () => <div className="text-right">Действия</div>,
      accessor: 'actions',
      disableSortBy: true,
      maxWidth: 150,
      width: 150,
      minWidth: 150,
      Cell: (cell: CellProps<ISegment>) => {
        const { id, name, can_edit: canEdit } = cell.row.original;
        return (
          <div className="text-right">
            <div className="d-inline-block mr-2">
              <TooltipWrapper
                id="tooltip-edit"
                overlay={canEdit ? 'Редактирай' : 'Глобалните сегменти не могат да бъдат редактирани'}
              >
                <Button
                  btnType="primary"
                  size="sm"
                  outlined
                  onClick={() => history.push(buildClientUrl(`/segments/edit/${id}`, client))}
                  disabled={!canEdit}
                >
                  <FaEdit size={14} />
                </Button>
              </TooltipWrapper>
            </div>
            <DeleteEntity
              id={id}
              entity={entityEndpoint}
              successMsg="Сегментът беше изтрит."
              confirmHeading="Изтриване на сегмент"
              confirmMsg={
                <span>
                  Сигурни ли сте, че желаете да изтриете сегмент&nbsp;
                  <span className="font-weight-bold">{name}</span>?
                </span>
              }
              queryKey={buildClientEntity(entityName, client)}
              isDisabled={!canEdit}
              disabledReason="Глобалните сегменти не могат да бъдат изтрити"
            />
          </div>
        );
      },
    },
  ];

  return (
    <MainLayout title="Управление на сегменти">
      <FetchTable<ISegment>
        entityName={buildClientEntity(entityName, client)}
        entityEndpoint={entityEndpoint}
        columns={columns}
        onAdd={createSegment}
        addBtnLabel="Добавяне на сегмент"
        pagination
      />
    </MainLayout>
  );
};

export default List;
